import React from "react";
import { Icon, IconProps } from "@iconify/react";
import Box from "@mui/material/Box";
import { SxProps } from "@mui/system";

interface IconifyProps extends Omit<IconProps, "icon"> {
  icon: string;
  width?: number;
  sx?: SxProps;
}

const Iconify: React.FC<IconifyProps> = ({ icon, width = 20, sx, ...other }) => (
  <Box sx={{ width, ...sx }}>
    <Icon icon={icon} {...other} />
  </Box>
);

export default Iconify;
